export default class LocalStorageService {
  get(key) {
    return window.localStorage.getItem(key);
  }

  set(key, value) {
    window.localStorage.setItem(key, value);
  }

  remove(key) {
    window.localStorage.removeItem(key);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/local-storage/local-storage.service.js